import Invoice from '@/models/Invoice';

const GET_INVOICES = 'get_invoices';
const GET_INVOICES_REQUEST = 'get_invoices_request';
const GET_INVOICES_SUCCESS = 'get_invoices_success';
const GET_INVOICES_ERROR = 'get_invoices_error';

export { GET_INVOICES };

export default {
    state: {
        invoices: [],
        loading: false,
        invoicesErrors: [],
        invoicesMeta: {},
    },
    mutations: {
        [GET_INVOICES_REQUEST]: (state) => {
            state.invoices = [];
            state.loading = true;
            state.invoicesErrors = [];
            // state.invoicesMeta = {};
        },
        [GET_INVOICES_SUCCESS]: (state, { invoices, meta }) => {
            state.invoices = invoices;
            state.loading = false;
            state.invoicesErrors = [];
            state.invoicesMeta = meta;
        },
        [GET_INVOICES_ERROR]: (state, { errors }) => {
            state.invoices = [];
            state.loading = false;
            state.invoicesErrors = errors;
            state.invoicesMeta = {};
        },
    },
    actions: {
        [GET_INVOICES]: ({ commit, state, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_INVOICES_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.invoicesMeta.current_page) {
                        params.page = state.invoicesMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                const TrajectoryInvoices = Invoice.makeModel(`/trajectories/${trajectoryId}/invoices`);
                TrajectoryInvoices.collection(params)
                    .then(({ items, meta }) => {
                        const invoices = items;
                        commit(GET_INVOICES_SUCCESS, { invoices, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_INVOICES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js